"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            Plugins: [
                'zoom',
                'airmeet',
                'bigbluebutton',
                'googlemeet',
                'slack',
                'mathlab',
                'paystack',
                'stripe',
                'paypal'
            ]
        };
        fhandler.bind(this, { plugins: [] });
        this.selected = [];
    },
    onInput: function (input) {
        input.reset && fhandler.reset();
    },
    onMount: function () {
        this.selected = this.state.form.plugins;
    },
    onPrev: function () {
        this.emit('prev', this.input.index);
    },
    onNext: function () {
        this.emit('next', this.input.index, this.state.form);
    },
    onSelect: function (name) {
        !this.selected.includes(name) ? this.selected.push(name) : this.selected = this.selected.filter(each => {
            return each !== name;
        });
        fhandler.set('plugins', this.selected);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Plugins.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_attrs0 = {
        "class": "w-100 px-lg-5 px-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ed695c"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/plugins.png",
        alt: "categories",
        width: "60",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "navigation-buttons"
      },
    marko_attrs4 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_attrs5 = {
        "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
      },
    marko_attrs6 = {
        "class": "col-md-4 col-6"
      },
    marko_attrs7 = {
        "class": "card-content"
      },
    marko_attrs8 = {
        "class": "card-body"
      },
    marko_attrs9 = {
        "class": "font-small-3"
      },
    marko_attrs10 = {
        "class": "col-4"
      },
    marko_attrs11 = {
        "class": "col"
      };

const fhandler = new FormHandler({ key: 'add-plugins', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Add some useful plugins");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        AutoScroll_tag({
            class: "position-relative row",
            height: "66vh",
            renderBody: function(out) {
              marko_forOf(state.Plugins, function(name, index) {
                var $keyValue$0 = "@" + ("pl-" + index),
                    $keyScope$0 = "[" + ($keyValue$0 + "]");

                out.be("div", marko_attrs6, $keyValue$0, component);

                out.be("div", {
                    "class": marko_classValue("card cursor-pointer " + (state.form.plugins.includes(name) ? "theme-bg-lighten" : ""))
                  }, "9" + $keyScope$0, component, null, 1, {
                    onclick: __component.d("click", "onSelect", false, [
                        name
                      ])
                  });

                out.be("div", marko_attrs7, "10" + $keyScope$0, component);

                out.be("div", marko_attrs8, "11" + $keyScope$0, component);

                Row_tag({
                    class: "d-flex align-items-center",
                    renderBody: function(out) {
                      out.be("div", marko_attrs10, "13" + $keyScope$0, component);

                      Image_tag({
                          alt: "Image",
                          src: ("/images/plugins/" + name.toLowerCase()) + ".png",
                          style: "height:35px"
                        }, out, __component, "14" + $keyScope$0);

                      out.ee();

                      out.e("div", marko_attrs11, "15" + $keyScope$0, component, 1)
                        .t(name.toCapitalCase(), component);
                    }
                  }, out, __component, "12" + $keyScope$0);

                out.e("br", null, "16" + $keyScope$0, component, 0);

                out.e("p", marko_attrs9, "17" + $keyScope$0, component, 1)
                  .t("Sed do sunt in culpa qui officia deserunt mollit sunt in culpa cia dese...");

                out.ee();

                out.ee();

                out.ee();

                out.ee();
              });
            }
          }, out, __component, "8");

        out.ee();

        out.n(marko_node3, component);

        out.n(marko_node4, component);

        out.be("div", marko_attrs3, "20", component);

        out.be("button", marko_attrs4, "21", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "22");

        out.ee();

        out.be("button", marko_attrs5, "23", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "24");

        Locale_tag({
            text: "Continue"
          }, out, __component, "25");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
